import { useEffect, useRef } from "react";

// Closes a dropdown on a click or tap outside the element the returned ref is attached to
export const useCloseOnOutsideClick = (isOpen, setOpen) => {
  const ref = useRef(null);

  useEffect(() => {
    if (!isOpen) return;
    const onPointerDown = (event) => {
      if (ref.current && !ref.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener("pointerdown", onPointerDown);
    return () => document.removeEventListener("pointerdown", onPointerDown);
  }, [isOpen, setOpen]);

  return ref;
};
